import React from 'react';

import UserIcon from '@/components/Icons/icons/CustomContracts/UserIcon';

import CustomTooltip from '../../../../../common-components/CustomTooltip/CustomTooltip';
import LinkIcon from '../../../../../Icons/icons/LinkIcon';
import BookmarkIcon from '../../../../../Icons/icons/PlayerIcon/BookmarkIcon';
import { useCampaignDetail } from '../CampaignDetailProvider';

const ActionsSection = ({ url, post }) => {
  const { setLabelModalOpen } = useCampaignDetail();

  return (
    <div className="actions-container">
      <CustomTooltip title="Add Label" placement="top">
        <BookmarkIcon
          onClick={() => setLabelModalOpen({ post: post, openModal: 'addLabel' })}
          width={20}
          height={20}
          color="var(--purple-p-400)"
          className="cursor-pointer"
        />
      </CustomTooltip>
      <CustomTooltip title="View Profile" placement="top">
        <UserIcon
          strokeWidth={2}
          className="cursor-pointer"
          color="var(--purple-p-400)"
          onClick={() => {
            if (post?.profile?.listId && post?.profile?._id) {
              window.open(`/dashboard/profile/${post?.profile?.listId}/${post?.profile?._id}`, '_blank');
            }
          }}
        />
      </CustomTooltip>
      <CustomTooltip title="View Post" placement="top">
        <a href={url} target="__blank">
          <LinkIcon width={24} height={24} className="cursor-pointer" />
        </a>
      </CustomTooltip>
    </div>
  );
};

export default ActionsSection;
